export enum Roles {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  USER = 'USER',
  TRUSTED_USER = 'TRUSTED_USER',
}

/**
 * Порядок сортировки
 */
export enum Order {
  // По возрастанию
  ASC = 'asc',
  // По убыванию
  DESC = 'desc',
}

export enum screenDevices {
  Desktop = 1024,
  MaxTablet = 900,
  Tablet = 768,
  MiniTablet = 600,
  Mobile = 440,
}

export enum cardHeight {
  Desktop = 112,
  Indent = 12,
}

/**
 * Промежуточные вкладки
 */
export enum tabs {
  profile = 'profile',
  clients = 'clients',
  settings = 'settings',
  eventLog = 'event-log',
  users = 'users',
  systemProfile = 'system',
  scopes = 'scopes',
  catalog = 'catalog',
}

/**
 * Вкладки действий
 */
export enum subTabs {
  create = 'create',
  delete = 'delete',
  edit = 'edit',
}

/**
 * Изначальные роутеры
 */
export enum routes {
  profile = 'my',
  system = 'main',
  customer = 'app',
  admin = 'admin',
}

export enum filterMethods {
  all = 'Все',
  public = 'Публичные',
  private = 'Для приложения',
}

export enum RuleFieldNames {
  givenName = 'given_name',
  familyName = 'family_name',
  login = 'login',
  password = 'password',
  email = 'email',
  phoneNumber = 'phone_number',
  birthdate = 'birthdate',
  sub = 'sub',
  agreement = 'data_processing_agreement',
  picture = 'picture',
}

export enum endPoints {
  users = 'users',
  clients = 'clients',
  providers = 'providers',
  settings = 'settings',
  catalog = 'catalog',
  orgs = 'orgs',
}

export enum ETags {
  Catalog = 'Catalog',
  User = 'User',
  Claims = 'Claims',
  ExternalAccounts = 'ExternalAccounts',
  PublicExternalAccounts = 'PublicExternalAccounts',
  Providers = 'Providers',
  Settings = 'Settings',
  ProfileFields = 'ProfileFields',
  Rules = 'Rules',
  ClientTypes = 'ClientTypes',
  Clients = 'Clients',
  ClientDetails = 'ClientDetails',
  Cards = 'Cards',
  UserCards = 'UserCards',
  EmailTemplates = 'EmailTemplates',
  Organization = 'Organization',
  OrgLkSelfConnect = 'OrgLkSelfConnect',
  Billing = 'Billing',
}

export enum EEmailAction {
  account_create = 'account_create',
  confirmation_code = 'confirmation_code',
  confirmation_link = 'confirmation_link',
  password_change = 'password_change',
  password_recover = 'password_recover',
}

export enum ENoticeType {
  error = 'error',
  info = 'info',
  warning = 'warning',
}
